export class RecordingSource {
  constructor(
    public id: string,
    public name: string,
    public type: RecordingSourceType,
    public mediaUniqueIdTemplate: string,
    public referenceId: string,
    public recording: boolean = false,
    public image?: string,
    public streamingPlatformId?: number,
  ) {}
}

export enum RecordingSourceType {
  Channel,
  LiveFeed,
}
